
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useEffect, useState } from "react";
import useFetchApi from "../../hooks/useFetchApi";

function CalenderBooking() {
    //const [data, setData] = useState([]);
    //const [error, setError] = useState(null);
    const localizer = momentLocalizer(moment);

    // useEffect(() => {
    //     fetchData();
    // }, [])
    // const fetchData = async () => {
    //     try {
    //         // setLoading(true);
    //         const res = await fetch('https://orisoftpl.com/backend/api/admin/dashboard', {
    //             headers: {
    //                 Accept: "application/json",
    //             }
    //         });

    //         const result = await res.json();

    //         // console.log('data', result);


    //         setData(result.recentBookings || []);
    //     } catch (error) {
    //         setError(error.message);
    //     }
    // }

    // const { data, loading, error } = useFetchApi({
    //     url: "https://orisoftpl.com/backend/api/admin/dashboard",
    //     dataKey: "recentBookings",
    //     token: localStorage.getItem("admin_token"),
    // });

    const { data, loading, error } = useFetchApi({
        url: 'https://orisoftpl.com/backend/api/admin/dashboard',
        dataKey: 'recentBookings',
        authType: 'admin'// ✅ auth token
    });

    const events = data.map((item) => ({
        title: `${item.mandap?.name} (${item.status_label})`,
        allDay: true,
        start: new Date(item.from_date),
        end: new Date(item.to_date),
    }));

    console.log('calender Data:', data);
    console.log('events:-', events);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;
    return (
        <>
            <div className="bg-white rounded shadow-lg mt-5">
                <h4 className="text-lg p-4 font-semibold border-b">Booking Calender</h4>
                <div className="p-4 h-[800px]">
                    {/* <Calendar
                        localizer={localizer}
                        events={events}
                        startAccessor="start"
                        endAccessor="end"
                        // 👇 ADD IT HERE
                        eventPropGetter={(event) => {
                            let bg = "#6b7280";

                            if (event.title.includes("Approved")) bg = "#22c55e";
                            if (event.title.includes("Pending")) bg = "#f59e0b";
                            if (event.title.includes("Rejected")) bg = "#ef4444";

                            return {
                                style: {
                                    backgroundColor: bg,
                                    color: "white",
                                },
                            };
                        }}
                        style={{ height: "100%" }}
                    /> */}

                    <Calendar
                        localizer={localizer}
                        events={events}
                        startAccessor="start"
                        endAccessor="end"
                        eventPropGetter={(event) => {
                            const isApproved = event.title.includes("Approved");

                            return {
                                style: {
                                    backgroundColor: isApproved
                                        ? "#22c55e"
                                        : "#ef4444",
                                    color: "white",
                                },
                            };
                        }}
                        style={{ height: "100%" }}
                    />
                </div>
            </div>
        </>
    )
}

export default CalenderBooking